import axios from "axios";

export const fetchDeleteTaskCounterTemplate = async (id: number) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
  return await axios.delete(`${baseTaskUrl}/TaskCounterTemplate/${id}`);
};
